<template>
  <div v-if="isExternalLink">
    <a :href="url" :class="classList">
      <font-awesome-icon :icon="icon" /> {{name}}
      <b-badge v-if="badge && badge.text" :variant="badge.variant">{{badge.text}}</b-badge>
    </a>
  </div>
  <div v-else-if="url">
    <router-link :to="url" :class="classList">
      <font-awesome-icon :icon="icon" /> {{name}}
      <b-badge v-if="badge && badge.text" :variant="badge.variant">{{badge.text}}</b-badge>
      <font-awesome-icon v-if="!hasRequiredFeature" icon="lock" class="ms-auto nav-link-lock" />
    </router-link>
  </div>
  <div v-else :class="classList">
      <font-awesome-icon :icon="icon" /> {{name}}
      <b-badge v-if="badge && badge.text" :variant="badge.variant">{{badge.text}}</b-badge>
  </div>
</template>

<script>
// @ts-expect-error: No type declaration for store
import store from '@/store'

export default {
  name: 'sidebar-nav-link',
  data () {
    return {
      store
    }
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    requireFeature:{
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: () => {}
    },
    variant: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList () {
      return [
        'nav-link',
        this.linkVariant,
        ...this.itemClasses
      ]
    },
    linkVariant () {
      return this.variant ? `nav-link-${this.variant}` : ''
    },
    itemClasses () {
      return this.classes ? this.classes.split(' ') : []
    },
    isExternalLink () {
      if (this.url.substring(0, 4) === 'http') {
        return true
      } else {
        return false
      }
    },
    hasRequiredFeature () {
      if(!this.requireFeature) {
        return true
      }
      return this.store.state.features.includes(this.requireFeature)
    }
  }
}
</script>

<style scoped>
.nav-link-lock {
  float: right !important;
  width: auto !important;
  margin-right: 0;
}
</style>
